const X_MARK_SVG =
  '<svg viewBox="0 0 24 24" stroke-width="1.5"><path d="M 19.5 4.5 L 4.5 19.5 M 4.5 4.501 L 19.5 19.5"></path></svg>';
const CONTAINER_SELECTOR = '#cc-main';
const DEFAULT_PREFERENCES_MODAL_OPTIONAL_CATEGORIES = {
  analytics: false,
  functional: false,
  marketing: false
};
const DEFAULT_PREFERENCES_MODAL_OPTIONAL_CATEGORIES_BY_LANGUAGE = {
  en: {
    ...DEFAULT_PREFERENCES_MODAL_OPTIONAL_CATEGORIES
  },
  it: {
    ...DEFAULT_PREFERENCES_MODAL_OPTIONAL_CATEGORIES
  },
  us: {
    analytics: true,
    functional: true,
    marketing: true
  }
};

export const addCloseButton = (sourceOptions = {}) => {
  const DEFAULT_OPTIONS = {
    view: 'icon', // icon, text
    text: 'Close',
    handler: () => {},
    attributes: [] // [{ name, value }]
  };

  const options = {
    ...DEFAULT_OPTIONS,
    ...sourceOptions
  };

  const createButton = () => {
    const button = document.createElement('button');

    button.classList.add('close-btn');
    button.setAttribute('type', 'button');

    if (options.view === 'text') {
      button.textContent = options.text;
      button.classList.add('close-btn--text');
    } else if (options.view === 'icon') {
      button.innerHTML = X_MARK_SVG;
    }

    options.attributes.forEach(({ name, value }) => {
      button.setAttribute(name, value);
    });

    button.addEventListener('click', options.handler);

    return button;
  };

  const container = document.querySelector(CONTAINER_SELECTOR);

  if (!container) return;

  const titleElement = container.querySelector('#cm__title');
  const modalElement = titleElement.closest('.cm__body');

  const button = createButton();

  modalElement.append(button);
};

export const addLanguageClassForContainer = (language = '') => {
  if (!language) return;

  const container = document.querySelector(CONTAINER_SELECTOR);
  if (!container) return;

  container.classList.add('cc', `cc--${language.toLowerCase()}`);
};

export const setPreferencesCategoryValuesByLanguage = (language = '') => {
  const container = document.querySelector(CONTAINER_SELECTOR);
  if (!container) return;

  const checkboxesNodeList = container.querySelectorAll('input[type="checkbox"].section__toggle:not([disabled])');
  const checkboxes = Array.from(checkboxesNodeList);

  checkboxes.forEach((checkbox) => {
    const category = checkbox.getAttribute('value');
    const values = DEFAULT_PREFERENCES_MODAL_OPTIONAL_CATEGORIES_BY_LANGUAGE[language] || DEFAULT_PREFERENCES_MODAL_OPTIONAL_CATEGORIES;

    checkbox.checked = values[category] || false;
  });
};
